(() => {
  'use strict';
  const root = document.querySelector('[data-hero-showcase]');
  if (!root) return;
  const scenes = [...root.querySelectorAll('[data-hero-scene]')];
  const shelves = [...root.querySelectorAll('[data-hero-shelf]')];
  const choices = [...root.querySelectorAll('[data-hero-choice]')];
  const controls = root.querySelector('[data-hero-controls]');
  const toggle = root.querySelector('[data-hero-toggle]');
  const status = root.querySelector('[data-hero-status]');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const stage = root.querySelector('[data-hero-stage]');
  const drawer = document.querySelector('[data-cart-drawer]');
  const menu = document.querySelector('.mobile-menu');
  const duration = Number(root.dataset.interval) || 5000;
  let index = 0, timer = 0, visible = false, keyboardFocus = false;
  let keyboardInput = false;
  const pointers = new Set();
  const productNavigators = [];
  let paused = reduced.matches, started = 0, remaining = duration;
  let pointerStart = null, suppressClick = false;

  const cancel = () => {
    if (timer) remaining = Math.max(0, remaining - (performance.now() - started));
    clearTimeout(timer);
    timer = 0;
    root.dataset.running = 'false';
  };
  const canRun = () => !paused && visible && !keyboardFocus && pointers.size === 0 && !document.hidden &&
    !drawer?.open && !menu?.open && !reduced.matches;
  const sync = () => {
    cancel();
    toggle.textContent = paused || reduced.matches ? 'Reanudar' : 'Pausar';
    toggle.setAttribute('aria-label', paused || reduced.matches ? 'Reanudar cambios automáticos' : 'Pausar cambios automáticos');
    toggle.disabled = reduced.matches;
    root.dataset.paused = String(paused || reduced.matches);
    if (!canRun()) return;
    root.dataset.running = 'true';
    started = performance.now();
    timer = setTimeout(() => { timer = 0; show(index + 1); }, remaining);
  };
  const stop = () => { paused = true; sync(); };
  const restart = () => { cancel(); remaining = duration; sync(); };
  const show = (next, manual = false) => {
    cancel();
    index = (next + scenes.length) % scenes.length;
    scenes.forEach((scene, i) => { scene.hidden = i !== index; scene.inert = i !== index; });
    shelves.forEach((shelf, i) => { shelf.hidden = i !== index; shelf.inert = i !== index; });
    choices.forEach((choice, i) => choice.setAttribute('aria-pressed', String(i === index)));
    // Keep the current category visible within the mobile tab row without
    // changing the page's vertical scroll position.
    const choiceRow = choices[index]?.parentElement;
    if (choiceRow && choiceRow.scrollWidth > choiceRow.clientWidth) {
      const rowBounds = choiceRow.getBoundingClientRect();
      const activeBounds = choices[index].getBoundingClientRect();
      if (activeBounds.left < rowBounds.left || activeBounds.right > rowBounds.right) {
        choiceRow.scrollTo({
          left: choiceRow.scrollLeft + activeBounds.left - rowBounds.left - (rowBounds.width - activeBounds.width) / 2,
          behavior: reduced.matches ? 'instant' : 'smooth'
        });
      }
    }
    // Load the next hero only after the active campaign has been rendered.
    scenes[(index + 1) % scenes.length]?.querySelectorAll('img').forEach(img => { img.loading = 'eager'; });
    root.dataset.active = String(index);
    remaining = duration;
    productNavigators[index]?.();
    if (manual) {
      status.textContent = `${choices[index].textContent.trim()}: banner y productos seleccionados.`;
    }
    sync();
  };
  choices.forEach((choice, i) => choice.addEventListener('click', () => show(i, true)));
  root.querySelector('[data-hero-prev]').addEventListener('click', () => show(index - 1, true));
  root.querySelector('[data-hero-next]').addEventListener('click', () => show(index + 1, true));
  toggle.addEventListener('click', () => { paused = !paused; remaining = duration; sync(); });
  // Only explicit pause is persistent. Touch, product browsing and selection
  // grant a fresh five seconds; keyboard focus protects the focused content.
  document.addEventListener('keydown', () => { keyboardInput = true; });
  root.addEventListener('focusin', event => {
    keyboardFocus = keyboardInput && Boolean(event.target.closest('[data-hero-shelf], [data-hero-stage]'));
    sync();
  });
  root.addEventListener('focusout', event => {
    keyboardFocus = keyboardInput && Boolean(event.relatedTarget?.closest('[data-hero-shelf], [data-hero-stage]'));
    restart();
  });
  root.addEventListener('pointerdown', event => {
    keyboardInput = false;
    keyboardFocus = false;
    pointers.add(event.pointerId);
    cancel();
  });
  const release = event => {
    if (pointers.delete(event.pointerId)) restart();
  };
  document.addEventListener('pointerup', release);
  document.addEventListener('pointercancel', release);
  root.addEventListener('submit', restart, true);
  root.addEventListener('keydown', event => { if (event.key === 'Escape') stop(); });
  shelves.forEach(shelf => {
    const row = shelf.querySelector('.showcase-product-row');
    const cards = [...row.querySelectorAll('.product-card')];
    const nav = shelf.querySelector('[data-product-nav]');
    const previous = nav.querySelector('[data-products-prev]');
    const next = nav.querySelector('[data-products-next]');
    const count = nav.querySelector('[data-product-count]');
    const update = () => {
      if (shelf.hidden || !row.clientWidth) return;
      const bounds = row.getBoundingClientRect();
      const visibleCards = cards.map((card, i) => ({ i, rect: card.getBoundingClientRect() }))
        .filter(({ rect }) => rect.right > bounds.left + 4 && rect.left < bounds.right - 4);
      if (visibleCards.length) count.textContent = `${visibleCards[0].i + 1}–${visibleCards[visibleCards.length - 1].i + 1} de ${cards.length}`;
      const max = Math.max(0, row.scrollWidth - row.clientWidth);
      previous.disabled = row.scrollLeft <= 2;
      next.disabled = row.scrollLeft >= max - 2;
      nav.hidden = max <= 2;
    };
    const page = direction => {
      restart();
      row.scrollBy({ left: direction * (row.clientWidth + 10), behavior: reduced.matches ? 'instant' : 'smooth' });
    };
    previous.addEventListener('click', () => page(-1));
    next.addEventListener('click', () => page(1));
    row.addEventListener('scroll', () => { update(); restart(); }, { passive: true });
    productNavigators.push(update);
    new ResizeObserver(update).observe(row);
  });
  stage.addEventListener('pointerdown', event => {
    if (event.pointerType === 'touch') { pointerStart = { x: event.clientX, y: event.clientY }; }
  });
  stage.addEventListener('pointerup', event => {
    if (!pointerStart) return;
    const dx = event.clientX - pointerStart.x, dy = event.clientY - pointerStart.y;
    pointerStart = null;
    if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.4) {
      suppressClick = true;
      show(index + (dx < 0 ? 1 : -1), true);
      setTimeout(() => { suppressClick = false; }, 350);
    }
  });
  stage.addEventListener('pointercancel', () => { pointerStart = null; });
  stage.addEventListener('click', event => {
    if (suppressClick) { event.preventDefault(); event.stopPropagation(); suppressClick = false; }
  }, true);
  // The campaign includes its products: keep rotating when the banner has
  // scrolled away but the customer can still see the associated product row.
  new IntersectionObserver(entries => {
    visible = entries[0].isIntersecting;
    sync();
  }, { threshold: 0 }).observe(root);
  document.addEventListener('visibilitychange', () => { pointers.clear(); pointerStart = null; restart(); });
  reduced.addEventListener('change', () => { if (reduced.matches) paused = true; sync(); });
  if (drawer) new MutationObserver(sync).observe(drawer, { attributes: true, attributeFilter: ['open'] });
  menu?.addEventListener('toggle', sync);
  window.addEventListener('pagehide', cancel);
  window.addEventListener('pageshow', sync);
  controls.hidden = scenes.length < 2;
  root.dataset.enhanced = 'true';
  show(0);
})();
